/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import React from "react";
import { useParams } from "react-router-dom";
import { useCreateStockManufactureMutation } from "../../../slices/stockManufactureApiSlice";
import { Row, Col, Image, ListGroup, Card } from "react-bootstrap";
import Loader from "../../../components/Loader";
import Message from "../../../components/Message";

const StockCreateManufacturingScreen = () => {
  return <div>StockCreateManufacturingScreen</div>;
};

export default StockCreateManufacturingScreen;
